<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">Table of Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/dedication#urbDHPXfkJglm5sV43yPgk7">Dedication</a>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_01#uxpzOuqAjbtsfPbxrRDsce6">Chapter One</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_02#utkDrn8F3sTavmDl8MycmK8">Chapter Two</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_03#uuLdIDJLky6Py3VUGjqPOHA">Chapter Three</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_04#udPHdv2JDwlGs4L4ZhOjd39">Chapter Four</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_05#u6DJlUowpL3suhZVFM5e2N8">Chapter Five</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_06#uuIrOX77254vGNhCzelFlZB" title="Link target outside of Sample">Chapter Six</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_07#ucrYph562Z5UuboxSnDoDx3" title="Link target outside of Sample">Chapter Seven</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_08#uzrPuFWohJXcW6om7GhHWCE" title="Link target outside of Sample">Chapter Eight</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_09#ujNBquuMUlBcH8vxX75CP8F" title="Link target outside of Sample">Chapter Nine</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_10#uOjTYyr5Cdalilj2hTJ87PD" title="Link target outside of Sample">Chapter Ten</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_11#uH7nmFk7z8ypegd5onoshSE" title="Link target outside of Sample">Chapter Eleven</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_12#uFpb7biaiNwjciNhM2ksBm6" title="Link target outside of Sample">Chapter Twelve</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_13#ueQYTcMbAikKkPwqPKNWlQB" title="Link target outside of Sample">Chapter Thirteen</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_14#uw6AH8F5C4KAmoSSF3xLxCC" title="Link target outside of Sample">Chapter Fourteen</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_15#usF26UsHXQuVKIQMnTOgxh7" title="Link target outside of Sample">Chapter Fifteen</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_16#ulV9TXEoDQFc7hSW6Jhsc6G" title="Link target outside of Sample">Chapter Sixteen</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_17#uyQLFdXHxturVXtHLrrtSF4" title="Link target outside of Sample">Chapter Seventeen</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_18#ugt7Gx5B6VdNcdEkTRTXj8G" title="Link target outside of Sample">Chapter Eighteen</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_19#uLRt5zFFeCHQ2vKvkG6Nll2" title="Link target outside of Sample">Chapter Nineteen</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_20#ufswqp5KmYyAkgBlgxdOxn6" title="Link target outside of Sample">Chapter Twenty</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_21#uY9lUu2onqfVt4XI4rETDW4" title="Link target outside of Sample">Chapter Twenty-One</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_22#usdDM25T7QjkVILYZQW3aE6" title="Link target outside of Sample">Chapter Twenty-Two</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_23#uc8ujir4WPB7DBCcUZ94L6C" title="Link target outside of Sample">Chapter Twenty-Three</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_24#uDk7UdBMPsoH5yTQMIVyvyF" title="Link target outside of Sample">Chapter Twenty-Four</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_25#uDNgpnYjtk2v5eVBu3JA4b2" title="Link target outside of Sample">Chapter Twenty-Five</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_26#ubJPHUrXCrbfvUqdQFfpRIF" title="Link target outside of Sample">Chapter Twenty-Six</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_27#uFVp8XS2ew5zNkSttvsAhC4" title="Link target outside of Sample">Chapter Twenty-Seven</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_28#uGsA2snncvr5CAHLvkDquvE" title="Link target outside of Sample">Chapter Twenty-Eight</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Epilogue#uI9oSOCIqKxvgbE6YH6xLXB" title="Link target outside of Sample">EPILOGUE</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?c24840f4